// src/encounter/services/use-patient-detail.ts
// GET /api/Patients/{id} → PatientDetail. Carries patientOccupation / patientEducation, which the
// aggregate GetPatientSummary does NOT include (Flutter reads them off the patient model, not the
// summary). Used by the pre-encounter rail's Occupation/Education cards (PROD-1270). AbortSignal
// forwarded.
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { PatientDetail } from '@/types/patient-detail-api';

export function usePatientDetail(patientId: string | null | undefined) {
  return useQuery<PatientDetail>({
    queryKey: ['patient-detail', patientId],
    enabled: !!patientId,
    queryFn: ({ signal }) =>
      get<PatientDetail>(`/api/Patients/${encodeURIComponent(patientId as string)}`, { signal }),
  });
}
